import { ApplicationRef, EnvironmentInjector, Injectable, Injector, createComponent } from '@angular/core';
import * as L from 'leaflet';

import { MapPopupComponent } from './map-popup/map-popup.component';

@Injectable()
export class PopUpService {
  defaultConfig: L.PopupOptions = {
    autoPan: true,
    closeButton: false,
    minWidth: 300,
    autoPanPadding: [50, 50]
  };

  constructor(
    private injector: Injector,
    private environmentInjector: EnvironmentInjector,
    private applicationRef: ApplicationRef
  ) {}

  makePopup(data: any): string {
    return data.properties.name_nl;
  }

  compilePopup(data: any): any {
    const element = document.createElement('div');
    const component = createComponent(MapPopupComponent, {
      elementInjector: this.injector,
      environmentInjector: this.environmentInjector,
      hostElement: element
    });
    this.applicationRef.attachView(component.hostView);
    component.instance.data = data;
    return element;
  }
}
